import { render } from "./WithdrawDetail.vue?vue&type=template&id=556b4fb8"
import script from "./WithdrawDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawDetail.vue?vue&type=script&lang=js"

import "./WithdrawDetail.vue?vue&type=style&index=0&id=556b4fb8&lang=css"

import exportComponent from "D:\\WORK\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__